import Modal from "../Modal";
import { useMutation, useQuery } from "@apollo/client";
import {  GET_USER, LOGIN } from "../../../graphql/auth";
import GInput from "../base/GInput";
import GCheckbox from "../base/GCheckbox";
import GButton from "../base/GButton";
import { useState } from "react";
import useMainStore from "../../../store/mainState";
import { useTranslation } from 'react-i18next';
interface SignInProps {
    isOpen: boolean;
    onClose: () => void;
    openSignUp: () => void;
}

const SignIn = ({ isOpen, onClose, openSignUp }: SignInProps) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const { setIsLoading, user, setUser, setIsSignInOpen, setIsResetPasswordOpen } = useMainStore();
    const { t } = useTranslation();
    const [userId, setUserId] = useState<number | null>(null);
    const [loginMobile, { data, loading, error }] = useMutation(LOGIN, { errorPolicy: 'all' });
    const { loading: userLoading, error: userError, data: userData, refetch: refetchUser } = useQuery(GET_USER, {
        variables: { id: userId },
        skip: !userId, // Skip the query if no userId
        fetchPolicy: 'cache-and-network' // Always refetch from server
    });

    const onSetUserName = (value: string) => {
        setUsername(value);
        setErrorMessage("");
    }
    const onSetUserPassword = (value: string) => {
        setPassword(value);
        setErrorMessage("");
    }

    const onOpenSignUp = () => {
        onClose();
        openSignUp();
    }

    const onSubmit = async () => {
        setIsLoading(true);
        setErrorMessage("");
        try {
            const result = await loginMobile({
                variables: {
                    username: username,
                    password: password
                }
            })
            // Check for GraphQL errors in the response
            if (result.errors && result.errors.length > 0) {
                setErrorMessage(result.errors[0].message || t('auth.loginFailed'));
            } else if (result.data?.loginWeb) {
                const { accessToken } = result.data.loginWeb;

                await localStorage.setItem("authToken", accessToken);
                await localStorage.setItem("userId", result.data.loginWeb.user.id);
                setUserId(result.data.loginWeb.user.id);

                const refetchUserResponse = await refetchUser({ variables: { id: Number(result.data.loginWeb.user.id) } });
                setUser(refetchUserResponse?.data?.user);
                setIsSignInOpen(false);
            } else {
                setErrorMessage(t('auth.loginFailed'));
            }
        } catch (error: any) {
            console.log(error);
            if (error?.graphQLErrors && error.graphQLErrors.length > 0) {
                setErrorMessage(error.graphQLErrors[0].message || t('auth.loginFailed'));
            } else if (error?.networkError) {
                setErrorMessage(t('auth.networkError'));
            } else if (error?.message) {
                setErrorMessage(error.message);
            } else {
                setErrorMessage(t('auth.invalidCredentials'));
            }
        }
        setIsLoading(false);
    }
    const onResetPassword = () => {
        setIsSignInOpen(false);
        setIsResetPasswordOpen(true);
        
    }
    return (
        <Modal isOpen={isOpen} onClose={onClose} title={t('auth.signInTitle')} subTitle={t('auth.signInSubtitle')} leftContent={<img src={require("../../../assets/images/signIn.webp")} alt="" className="h-full object-fill w-full" />}>
            <div>
                {errorMessage && (
                    <div className="mb-5 px-4 py-3 bg-red-500/20 backdrop-blur-sm border border-red-500/40 rounded-[12px] shadow-[0_0_20px_rgba(239,68,68,0.15)] animate-[fadeIn_0.3s_ease-out]">
                        <p className="text-red-400 text-[14px] font-semibold">{errorMessage}</p>
                    </div>
                )}
                <GInput required className={errorMessage ? "w-full !border-red-500/50" : "w-full"} label={t('profile.email')} type="text" placeholder={t('profile.email')} onChange={(e) => onSetUserName(e.target.value)} />
                <GInput required className={errorMessage ? "w-full !border-red-500/50" : "w-full"} label={t('auth.password')} type="password" placeholder={t('auth.password')} onChange={(e) => onSetUserPassword(e.target.value)} />
                <div className="mt-[30px] mb-[15px] flex items-center justify-between">
                    <GCheckbox type="radio" label={t('auth.rememberMe')} isChecked={isChecked} setIsChecked={setIsChecked} />
                    <span className="text-white/50 text-[13px] font-medium cursor-pointer hover:text-white/80 transition-colors duration-200" onClick={onResetPassword}>{t('auth.forgotPassword')}</span>
                </div>

                <GButton disabled={!username || !password} className="w-full py-[16px] rounded-[12px]" onClick={onSubmit} isGradient={true}>{t('common.signIn')}</GButton>
                <p className="text-white text-[18px] font-medium mt-[20px] text-center">{t('auth.dontHaveAccount')} <span className="text-[#4DBDFF] cursor-pointer hover:text-[#0086D3] transition-colors" onClick={onOpenSignUp}>{t('common.signUp')}</span></p>
            </div>
        </Modal>
    )
}

export default SignIn